/**
 * Procedure Categories and Procedures for MD in Aerospace Medicine students
 * Extracted with strict evidence from official NMC PDF
 */
export const AEROSPACE_PROCEDURES = {
  "Aerospace & Hyperbaric Physiological Procedures": [
    "Head Up Tilt (HUT) Test & Cardiovascular Reflex Evaluation",
    "Human Centrifuge Training & Acceleration Tolerance Determination (+Gz / SACM)",
    "Decompression Chamber Operation & Testing",
    "Hyperbaric Oxygen Therapy (HBOT) Administration",
    "Dynamic Lung Function Testing & Spirometry",
    "Thermal Stress & Heat Strain Assessment",
  ],
  "Aircrew Equipment & Life Support Interventions": [
    "Aircrew Flying Clothing Sizing, Fitment, and Testing",
    "Aircraft Oxygen Systems Inspection and Maintenance",
  ],
};

export const AEROSPACE_CATEGORIES = Object.keys(AEROSPACE_PROCEDURES);

export const isMDInAerospaceDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("aerospace") || d.includes("aviation medicine");
};
